import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type PosePutPayload = {
  bvhContent: string;
  canvasImageBase64: string;
  title: string;
  duration: number;
  characterID?: string;
  objectID: string;
};

export default async function putPose(
  projectID: string,
  props: PosePutPayload,
) {
  const { data, error } = await apiRequest<ProjectFromAPI>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/pose`,
    {
      method: 'PUT',
      body: JSON.stringify(props),
    },
  );

  return { data: transformProjectResponse(data), error };
}
